"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function SearchResults({
  buttonProps = {},
  textMarket = "Market, State",
}) {
  return (
    <Link
      block={"inline"}
      button={false}
      className={"search-results-link-block"}
      options={{
        href: "#",
      }}
      {...buttonProps}
    >
      <Block className={"search-results---submarket-container"} tag={"div"}>
        <Block className={"text-block-3"} tag={"div"}>
          {textMarket}
        </Block>
      </Block>
    </Link>
  );
}
